import React from 'react'

const Stackedcard = ({ className }: { className?: string }) => {
    return (
        <svg className={className} width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.2584 4.7125L21.8067 4.10583V13.8883L24.4392 7.54C24.8834 6.435 24.3742 5.1675 23.2584 4.7125ZM2.13337 8.72083L7.5067 21.6667C7.66493 22.0605 7.93482 22.3996 8.2832 22.6421C8.63157 22.8846 9.04322 23.02 9.46754 23.0317C9.7492 23.0317 10.0417 22.9775 10.3234 22.8583L18.3075 19.5542C19.12 19.2183 19.6184 18.4167 19.64 17.615C19.6509 17.3333 19.5967 17.0192 19.4992 16.7375L14.0825 3.79167C13.9299 3.39485 13.6611 3.05331 13.3113 2.81171C12.9614 2.57011 12.5469 2.43969 12.1217 2.4375C11.84 2.4375 11.5584 2.5025 11.2875 2.6L3.3142 5.90417C2.7842 6.12121 2.36207 6.53984 2.14064 7.06803C1.91921 7.59622 1.91659 8.19072 2.13337 8.72083ZM19.6292 4.60417C19.6292 4.02953 19.4009 3.47843 18.9946 3.0721C18.5883 2.66577 18.0372 2.4375 17.4625 2.4375H15.8917L19.6292 11.4725" fill="white" />
        </svg>
    )
}

export default Stackedcard

